import request from '@/axios'
// import request from '@/utils/request'

//http://traqworx-backend.track-progress.com/api/activities/list_activities_notes/10/Leads/1
//notes
export function InsertNotes (query) {
  // 
  return request({
    url: '/activities/create_activities_notes',
    method: 'POST',
    data: query
  })
}

export function FetchLeadNotes (query, id, customerId) {
  return request({
    url:`/activities/list_activities_notes/10/CRM/${id}/${customerId}?page=${query}`,
    method:'GET'
  })
}

export function FetchSingleNotesId (id) {
  
  return request({
    url:`/activities/fetch_activites_notes/${id}`,
    method:'GET'
  })
}
export function UpdateActivityNotes (payload) {
  return request({
    url:'/activities/edit_activities_notes',
    method:'PUT',
    data: payload

  })
}
export function DeleteActivityNotes (id) {
  return request({
    url:`/activities/delete_activities_notes/${id}`,
    method:'GET'

  })
}

//notes

//task

export function FetchCustomerList (customerId) {
 
  return request({
    url:`/users/get_customer_user/${customerId}`,
    method:'GET'
  })
}
//task


export function InsertNewTask (query) {
  // 
  return request({
    url: '/activities/create_activities_task',
    method: 'POST',
    data: query
  })
}

//fetch activity Tasks
export function FetchLeadTask (query, id, customerId) {
  
  
  return request({
    url:`/activities/list_activities_task/10/Leads/${id}/${customerId}?page=${query}`,
    method:'GET'
  })
}

export function UpdateLeadTask (query) {
  // 
  // 
  return request({
    url:'/activities/edit_activities_task/',
    method:'PUT',
    data:query
  })
}


export function DeleteActivityTask (query) {
  // 
  // 
  return request({
    url:`/activities/delete_activities_task/${query}`,
    method:'GET'
    
  })
}


//fetch activity Task
// {
//   "activities_note_id" : 1,
//   "title" : "SUJAY",
//   "note_content" : "SUJAYSUJAYSUJAY"
// }
